import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import MetaView from "./meta";
import ReportView from "./report";
import ParamsMetaModel from "../../../../../../models/chart-reviews/drg-matchpoint-params-meta";
import templates from "../../../../../../utils/templates";
import environment from "../../../../../../common/environment";

const channel = Radio.channel("global");

const DEFAULTS = {
  template: templates.find("layout", "meta_and_report"),
};

class View extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      meta: ".meta",
      report: ".report",
    };
  }

  initialize() {
    // localize models passed in via options
    this.metaModel = this.options.data.chooserMetadata || null;
    this.chartModel = this.options.data.chartModel || null;

    // create params meta model
    const paramsMetaModelConfig = {
      paramTypeSetSid: this.metaModel.get("paramTypeSetSid"),
    };
    const _ParamsMetaModel = ParamsMetaModel.extend({
      urlRoot: environment.getEndpoint(
        "claims-matching:param-type-settings:meta",
        paramsMetaModelConfig
      ),
      initialize() {
        this.promise = this.fetch();
      },
    });
    this.paramsMetaModel = new _ParamsMetaModel({
      sid: this.metaModel.get("paramTypeSetSid"),
    });

    // load tab data on activation
    this.listenTo(channel, "tab-activated", this._onActivate);
  }

  // load views on activation
  _onActivate(tab) {
    if ("tab-matchpoint-param-type-settings" === tab) {
      this.meta.show(
        new MetaView({
          model: this.paramsMetaModel,
        })
      );

      // pass a route config object
      this.report.show(
        new ReportView({
          routeConfig: {
            paramTypeSetSid: this.metaModel.get("paramTypeSetSid"),
          },
        })
      );
    }
  }
}

export { View as default };
